import { Error } from "@mui/icons-material"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import { Button, Dialog, Paper, Typography } from "@mui/material"
import { makeStyles } from "@mui/styles"
import { Box, Theme } from "@mui/system"

type PropertyUpdatedDialogProps = {
  state: boolean
  onClose(): void
  error: boolean
  onRetry(): void
}

const PropertyUpdatedDialog: React.FC<PropertyUpdatedDialogProps> = ({
  state,
  onClose,
  error,
  onRetry,
}: PropertyUpdatedDialogProps) => {
  const classes = useStyles()
  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog open={state} maxWidth="md">
      <Box component={Paper} className={classes.root}>
        {error ? (
          <>
            <Box>
              <Error color="error" className={classes.icon} />
            </Box>
            <Typography variant="h6">Something went wrong</Typography>

            <Button
              variant="contained"
              color="primary"
              onClick={onRetry}
              fullWidth
            >
              Try Again
            </Button>
          </>
        ) : (
          <>
            <Box>
              <CheckCircleIcon color="success" className={classes.icon} />
            </Box>
            <Typography variant="h6">Property Updated</Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleClose}
              fullWidth
            >
              Close
            </Button>
          </>
        )}
      </Box>
    </Dialog>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    minHeight: 250,
    padding: theme.spacing(2),
    width: 400,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  icon: {
    width: `80px !important`,
    height: `80px !important`,
  },
}))

export default PropertyUpdatedDialog
